import React, { useEffect, useState } from 'react';
import './donation-management.scss';
import DonorHeaderComponent from './components/donor-header-component';
import DonorListComponent from './components/donor-list-component';
import DonorSubmitComponent from './components/donor-submit-component';

const DonationManagementPage = (props: any) => {
  return (
    <div className="donation-management">
      <DonorHeaderComponent />
      <DonorListComponent />
      <DonorSubmitComponent />
    </div>
  );
};

export default DonationManagementPage;
